var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"d-flex align-items-stretch",attrs:{"cols":"12","md":"6"}},[_c('SingleSwitch')],1),_c('b-col',{staticClass:"d-flex align-items-stretch",attrs:{"cols":"12","md":"6"}},[_c('SizeSwitch')],1),_c('b-col',{staticClass:"d-flex align-items-stretch",attrs:{"cols":"12","md":"6"}},[_c('GroupSwitch')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }